import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "dealer-invoice-create-page" }
const _hoisted_2 = { class: "create-steps" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "step-index" }, "1", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "开票信息", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "step-divider" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "step-index" }, "2", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "选择关联单据", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "section" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "开票信息", -1)
const _hoisted_12 = { class: "info-grid" }
const _hoisted_13 = { class: "info-item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("经销商")
], -1)
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "info-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("销售机构")
], -1)
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "info-item" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("开票信息")
], -1)
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "info-item" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("开票类型")
], -1)
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "info-item" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "寄送地址", -1)
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "info-item" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开票备注", -1)
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "info-item" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票抬头", -1)
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { class: "info-item" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "纳税人识别号", -1)
const _hoisted_37 = { class: "value" }
const _hoisted_38 = { class: "info-item" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开户银行", -1)
const _hoisted_40 = { class: "value" }
const _hoisted_41 = { class: "info-item" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "银行账号", -1)
const _hoisted_43 = { class: "value" }
const _hoisted_44 = { class: "info-item" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开票电话", -1)
const _hoisted_46 = { class: "value" }
const _hoisted_47 = { class: "info-item" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开票地址", -1)
const _hoisted_49 = { class: "value" }
const _hoisted_50 = { class: "section candidate-section" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "关联单据", -1)
const _hoisted_52 = {
  class: "notice-invoice-bar",
  style: {"display":"flex","align-items":"center","gap":"8px","margin-bottom":"12px"}
}
const _hoisted_53 = {
  class: "label",
  style: {"white-space":"nowrap"}
}
const _hoisted_54 = {
  key: 0,
  style: {"color":"#ff4d4f"}
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", {
  class: "tip",
  style: {"color":"#999"}
}, "仅当勾选的关联单据中存在负数（红字）单据时可填写且必填", -1)
const _hoisted_56 = { class: "search-bar" }
const _hoisted_57 = { class: "candidate-table-wrapper" }
const _hoisted_58 = { class: "vxe-table-container" }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "pagination-bar" }
const _hoisted_62 = { class: "create-footer" }
const _hoisted_63 = { class: "selected-summary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_oio_input = _resolveComponent("oio-input")!
  const _component_oio_spin = _resolveComponent("oio-spin")!
  const _component_oio_form_item = _resolveComponent("oio-form-item")!
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_oio_form = _resolveComponent("oio-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_OioTag = _resolveComponent("OioTag")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_OioPagination = _resolveComponent("OioPagination")!
  const _component_SpecifyInvoiceDialog = _resolveComponent("SpecifyInvoiceDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["step-item", _ctx.currentStep === 0 ? 'active' : 'done'])
      }, _hoisted_5, 2),
      _hoisted_6,
      _createElementVNode("div", {
        class: _normalizeClass(["step-item", _ctx.currentStep === 1 ? 'active' : ''])
      }, _hoisted_9, 2)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createVNode(_component_oio_spin, { loading: _ctx.invoiceInfoLoading }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, [
                _createVNode(_component_a_select, {
                  value: _ctx.form.distributorCode,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.distributorCode) = $event)),
                  "show-search": "",
                  "allow-clear": "",
                  placeholder: "输入ERP客户编码或经销商名称检索",
                  style: {"width":"100%"},
                  class: "oio-select",
                  "dropdown-class-name": "oio-select-dropdown",
                  "filter-option": false,
                  loading: _ctx.distributorLoading,
                  options: _ctx.distributorOptions,
                  onSearch: _ctx.handleDistributorSearch,
                  onChange: _ctx.handleDistributorChange
                }, null, 8, ["value", "loading", "options", "onSearch", "onChange"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("span", _hoisted_18, [
                _createVNode(_component_a_select, {
                  value: _ctx.form.salesOrgCode,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.salesOrgCode) = $event)),
                  "allow-clear": "",
                  placeholder: _ctx.form.distributorCode ? '请选择销售机构' : '请先选择经销商',
                  style: {"width":"100%"},
                  class: "oio-select",
                  "dropdown-class-name": "oio-select-dropdown",
                  disabled: !_ctx.form.distributorCode,
                  loading: _ctx.salesOrgLoading,
                  onChange: _ctx.handleSalesOrgChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salesOrgOptions, (org) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: org.salesOrgCode,
                        value: org.salesOrgCode
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(org.salesOrgCode) + " " + _toDisplayString(org.salesOrgName || '') + _toDisplayString(org.isDefault ? '（默认）' : ''), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "placeholder", "disabled", "loading", "onChange"])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("span", _hoisted_21, [
                _createVNode(_component_a_tooltip, { title: _ctx.invoiceInfoDisabledTip }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.selectedInvoiceInfoId,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedInvoiceInfoId) = $event)),
                      placeholder: _ctx.invoiceInfoPlaceholder,
                      style: {"width":"100%"},
                      class: "oio-select",
                      "dropdown-class-name": "oio-select-dropdown",
                      disabled: _ctx.invoiceInfoDisabled,
                      "show-search": "",
                      "filter-option": false,
                      onSearch: _ctx.handleInvoiceInfoSearch,
                      onChange: _ctx.handleInvoiceInfoSelectChange,
                      "allow-clear": ""
                    }, {
                      default: _withCtx(() => [
                        (_ctx.hasArchiveDefault)
                          ? (_openBlock(), _createBlock(_component_a_select_option, {
                              key: 0,
                              value: _ctx.DEFAULT_INVOICE_INFO
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("客户信息（默认）")
                              ]),
                              _: 1
                            }, 8, ["value"]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredInvoiceInfoOptions, (info) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: info.id,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.code) + " - " + _toDisplayString(info.invoiceTitle), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "placeholder", "disabled", "onSearch", "onChange"])
                  ]),
                  _: 1
                }, 8, ["title"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("span", _hoisted_24, [
                _createVNode(_component_a_select, {
                  value: _ctx.form.billingType,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.billingType) = $event)),
                  style: {"width":"100%"},
                  class: "oio-select",
                  "dropdown-class-name": "oio-select-dropdown"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableBillingTypes, (text, key) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: key,
                        value: key
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(text), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("span", _hoisted_27, [
                (_ctx.isDefaultInvoiceInfo)
                  ? (_openBlock(), _createBlock(_component_oio_input, {
                      key: 0,
                      value: _ctx.form.deliveryAddress,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.deliveryAddress) = $event)),
                      placeholder: "请填写发票邮寄地址",
                      style: {"width":"100%"}
                    }, null, 8, ["value"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.currentInvoiceInfo.deliveryAddress || '-'), 1))
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("span", _hoisted_31, [
                _createVNode(_component_oio_input, {
                  value: _ctx.form.remark,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.remark) = $event)),
                  placeholder: "选填，同步 SAP",
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.currentInvoiceInfo.invoiceTitle || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.currentInvoiceInfo.taxNo || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.currentInvoiceInfo.bankName || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.currentInvoiceInfo.bankAccount || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.currentInvoiceInfo.phone || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.currentInvoiceInfo.address || '-'), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["loading"])
    ], 512), [
      [_vShow, _ctx.currentStep === 0]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_50, [
      _hoisted_51,
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("span", _hoisted_53, [
          (_ctx.hasNegativeSelected)
            ? (_openBlock(), _createElementBlock("span", _hoisted_54, "*"))
            : _createCommentVNode("", true),
          _createTextVNode("红字通知单号")
        ]),
        _createVNode(_component_oio_input, {
          value: _ctx.form.noticeInvoiceNo,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.noticeInvoiceNo) = $event)),
          placeholder: _ctx.hasNegativeSelected ? '勾选含负数单据，必填' : '勾选单据无负数，不可填写',
          style: {"width":"280px"},
          disabled: !_ctx.hasNegativeSelected
        }, null, 8, ["value", "placeholder", "disabled"]),
        _hoisted_55
      ]),
      _createElementVNode("div", _hoisted_56, [
        _createVNode(_component_oio_form, {
          layout: "inline",
          data: _ctx.candidateSearch
        }, {
          default: _withCtx(() => [
            _createVNode(_component_oio_form_item, { label: "分销渠道编码" }, {
              default: _withCtx(() => [
                _createVNode(_component_oio_input, {
                  value: _ctx.candidateSearch.distributionChannelCode,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.candidateSearch.distributionChannelCode) = $event)),
                  placeholder: "分销渠道编码",
                  "allow-clear": "",
                  style: {"width":"140px"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_oio_form_item, { label: "80单号" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.candidateSearch.tmsOrderCodes,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.candidateSearch.tmsOrderCodes) = $event)),
                  mode: "tags",
                  placeholder: "支持批量输入/粘贴",
                  "allow-clear": "",
                  style: {"width":"200px"},
                  class: "single-line-select",
                  "token-separators": [',', '，', ' ', '\n'],
                  open: false,
                  "suffix-icon": null
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_oio_form_item, { label: "90单号" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.candidateSearch.order90Codes,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.candidateSearch.order90Codes) = $event)),
                  mode: "tags",
                  placeholder: "支持批量输入/粘贴",
                  "allow-clear": "",
                  style: {"width":"200px"},
                  class: "single-line-select",
                  "token-separators": [',', '，', ' ', '\n'],
                  open: false,
                  "suffix-icon": null
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_oio_form_item, { label: "开票状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.candidateSearch.lineStatus,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.candidateSearch.lineStatus) = $event)),
                  placeholder: "全部",
                  "allow-clear": "",
                  style: {"width":"130px"},
                  class: "oio-select",
                  "dropdown-class-name": "oio-select-dropdown"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billingLineStatusTextMap, (text, key) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: key,
                        value: key
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(text), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_oio_form_item, { label: "数据包号" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.candidateSearch.dataPackageNos,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.candidateSearch.dataPackageNos) = $event)),
                  mode: "tags",
                  placeholder: "支持批量输入/粘贴",
                  "allow-clear": "",
                  style: {"width":"180px"},
                  class: "single-line-select",
                  "token-separators": [',', '，', ' ', '\n'],
                  open: false,
                  "suffix-icon": null
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_oio_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_oio_button, {
                  type: "primary",
                  onClick: _ctx.handleCandidateSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_oio_button, {
                  style: {"margin-left":"8px"},
                  onClick: _ctx.handleCandidateReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_oio_button, {
                  style: {"margin-left":"8px"},
                  onClick: _ctx.handleSelectAllResult
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 全选查询结果 ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_oio_button, {
                  style: {"margin-left":"8px"},
                  onClick: _ctx.handleClearSelection
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("清空勾选")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createVNode(_component_vxe_table, {
            ref: "candidateTableRef",
            border: "",
            "column-config": { resizable: true },
            height: "auto",
            size: "small",
            "show-overflow": "",
            "show-header-overflow": "",
            data: _ctx.candidateData,
            loading: _ctx.candidateLoading,
            "scroll-x": { enabled: true },
            "scroll-y": { enabled: true, gt: 0 },
            "tooltip-config": { enterable: true },
            "checkbox-config": { highlight: true },
            "row-config": { keyField: 'candidateId', isCurrent: true, isHover: true },
            onCheckboxChange: _ctx.onCandidateCheckboxChange,
            onCheckboxAll: _ctx.onCandidateCheckboxChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_column, {
                type: "checkbox",
                width: "50",
                fixed: "left",
                align: "center"
              }),
              _createVNode(_component_vxe_column, {
                field: "tmsOrderCode",
                title: "80单号",
                width: "160",
                fixed: "left"
              }),
              _createVNode(_component_vxe_column, {
                field: "order90Code",
                title: "90单号",
                width: "150"
              }),
              _createVNode(_component_vxe_column, {
                field: "bizTime",
                title: "业务发生时间",
                width: "160"
              }),
              _createVNode(_component_vxe_column, {
                field: "outStockStatus",
                title: "出库状态",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.getOutStockStatusText(row.outStockStatus)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "distributionChannel",
                title: "分销渠道",
                width: "130"
              }),
              _createVNode(_component_vxe_column, {
                field: "taxInclusiveAmount",
                title: "价税合计",
                width: "120",
                align: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.getAmountClass(row.taxInclusiveAmount))
                  }, _toDisplayString(_ctx.formatAmount(row.taxInclusiveAmount)), 3)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "billingNetAmount",
                title: "开票净额",
                width: "120",
                align: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.getAmountClass(row.billingNetAmount))
                  }, _toDisplayString(_ctx.formatAmount(row.billingNetAmount)), 3)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "billingTaxAmount",
                title: "开票税额",
                width: "120",
                align: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.getAmountClass(row.billingTaxAmount))
                  }, _toDisplayString(_ctx.formatAmount(row.billingTaxAmount)), 3)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "profitCenter",
                title: "利润中心",
                width: "110"
              }),
              _createVNode(_component_vxe_column, {
                field: "companyCode",
                title: "公司代码",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "invoiceType",
                title: "发票类型",
                width: "100"
              }),
              _createVNode(_component_vxe_column, {
                field: "distributorErpCode",
                title: "ERP客户编码",
                width: "120"
              }),
              _createVNode(_component_vxe_column, {
                field: "salesOrgCode",
                title: "销售机构编码",
                width: "120"
              }),
              _createVNode(_component_vxe_column, {
                field: "salesOrgName",
                title: "销售机构名称",
                width: "150"
              }),
              _createVNode(_component_vxe_column, {
                field: "sourceDocType",
                title: "来源单据类型",
                width: "130"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.sourceDocTypeTextMap[row.sourceDocType] || row.sourceDocType || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "sourceDocCode",
                title: "来源单据编码",
                width: "160"
              }),
              _createVNode(_component_vxe_column, {
                field: "sapPackStatus",
                title: "SAP打包开票状态",
                width: "140"
              }, {
                default: _withCtx(({ row }) => [
                  (row.sapPackStatus)
                    ? (_openBlock(), _createBlock(_component_OioTag, {
                        key: 0,
                        color: _ctx.sapPackStatusColorMap[row.sapPackStatus] || 'default'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.sapPackStatusTextMap[row.sapPackStatus] || row.sapPackStatus), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_59, "-"))
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "packSyncSuccess",
                title: "打包状态同步",
                width: "120"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.packSyncSuccess ? '已同步' : '未同步'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "packSyncTime",
                title: "最后同步时间",
                width: "160"
              }),
              _createVNode(_component_vxe_column, {
                field: "lineStatus",
                title: "开票状态",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  (row.lineStatus)
                    ? (_openBlock(), _createBlock(_component_OioTag, {
                        key: 0,
                        color: _ctx.getLineStatusColor(row.lineStatus)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getLineStatusText(row.lineStatus)), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_60, "-"))
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_column, {
                field: "dataPackageNo",
                title: "数据包号",
                width: "160"
              })
            ]),
            _: 1
          }, 8, ["data", "loading", "onCheckboxChange", "onCheckboxAll"])
        ]),
        _createElementVNode("div", _hoisted_61, [
          _createVNode(_component_OioPagination, {
            currentPage: _ctx.candidatePagination.current,
            pageSize: _ctx.candidatePagination.pageSize,
            total: _ctx.candidatePagination.total,
            showTotal: "",
            showJumper: "",
            onChange: _ctx.handleCandidatePaginationChange
          }, null, 8, ["currentPage", "pageSize", "total", "onChange"])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.currentStep === 1]
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("span", _hoisted_63, [
        _createTextVNode(" 已勾选 " + _toDisplayString(_ctx.selectedCandidates.length) + " 条单据，价税合计 ", 1),
        _createElementVNode("b", {
          class: _normalizeClass(_ctx.getAmountClass(_ctx.selectedTaxInclusiveAmount))
        }, _toDisplayString(_ctx.formatAmount(_ctx.selectedTaxInclusiveAmount)), 3)
      ]),
      _createVNode(_component_oio_button, { onClick: _ctx.handleCancel }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.currentStep === 1)
        ? (_openBlock(), _createBlock(_component_oio_button, {
            key: 0,
            onClick: _ctx.handlePrevStep
          }, {
            default: _withCtx(() => [
              _createTextVNode("上一步")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.currentStep === 0)
        ? (_openBlock(), _createBlock(_component_oio_button, {
            key: 1,
            type: "primary",
            onClick: _ctx.handleNextStep
          }, {
            default: _withCtx(() => [
              _createTextVNode("下一步")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.currentStep === 1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_oio_button, {
              disabled: _ctx.selectedCandidates.length === 0,
              onClick: _ctx.handleSpecify
            }, {
              default: _withCtx(() => [
                _createTextVNode("指定开票")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_oio_button, {
              type: "primary",
              loading: _ctx.submitting,
              disabled: _ctx.selectedCandidates.length === 0,
              onClick: _ctx.handlePack
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 发起打包开票 ")
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_SpecifyInvoiceDialog, {
      visible: _ctx.specifyVisible,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.specifyVisible) = $event)),
      draft: true,
      "selected-lines": _ctx.specifySelectedLines,
      onDraftConfirm: _ctx.handleSpecifyDraftConfirm
    }, null, 8, ["visible", "selected-lines", "onDraftConfirm"])
  ]))
}